'use strict';

const setStoredLanguage = (state, language) => {
  state.language = language;
};

export default {
  setStoredLanguage
};
